import { z } from 'zod';
/**
 * Public Landing REST DTO — Phase 7 / Plan 07-02 (HUB-01).
 *
 * 엔드포인트 (공개 — SessionMiddleware `.exclude()`):
 *   - `GET /api/v1/public/landing` — 랜딩 `/` ISR 60s 로 조회하는 단일 payload.
 *
 * 불변 (07-02-PLAN Task 1 <behavior>):
 *   - `liveCards` 는 최대 6 건 (DESIGN-REVIEW-L3 §2.1 LIVE Strip ≥1600 해상도 기준).
 *   - `socialProof.totalDonationKrw` 는 `hardcoded floor` 허용 — 실 집계가 floor 미만이면
 *     floor 반환 (랜딩 `--` 방지 원칙, DESIGN-REVIEW-L3 §2.1).
 *   - `season` 은 Wave 0 에서 항상 `null` — seasons 테이블 도입 Wave 1 이후 동작.
 *   - `fetchedAt` 은 서버 snapshot 시각 (ISR 히트 여부 관측 참고).
 *
 * 위협 모델:
 *   - T-07-02-01 (Information Disclosure): 집계(SUM/COUNT)만 — 개별 payment/user row 금지.
 *   - T-07-02-02 (Tampering): viewerCount DESC 결정적 순위. Wave 1 추천 알고리즘 진입 전까지
 *     조작 surface 없음.
 */
/**
 * LIVE Strip 카드 1장.
 *
 * 서버 snapshot 기준 LIVE 상태 — ISR 60s 캐시로 최대 60s 지연 허용.
 * 진짜 실시간은 Plan 07-03 `/s/{slug}` SSE LIVE 배지가 담당.
 */
export const liveCardSchema = z.object({
    streamerId: z.string().uuid(),
    channelSlug: z.string().min(1).max(64),
    displayName: z.string(),
    avatarUrl: z.string().url().nullable(),
    isLive: z.boolean(),
    viewerCount: z.number().int().nonnegative().nullable(),
    category: z.string().nullable(),
    platform: z.enum(['chzzk', 'soop', 'youtube', 'twitch']).nullable(),
});
/**
 * 소셜 증거 — 누적 후원 / 활성 팬 / 스트리머 수.
 * 모두 집계 숫자만 (개별 row 금지 — T-07-02-01).
 */
export const socialProofSchema = z.object({
    /** 누적 후원 총액 (KRW). hardcoded floor 허용. */
    totalDonationKrw: z.number().int().nonnegative(),
    /** 최근 30 일 내 후원 내역 1 건 이상 보유한 유저 수. */
    activeFanCount: z.number().int().nonnegative(),
    /** `tossSellerStatus != 'NOT_SUBMITTED'` 스트리머 수. */
    streamerCount: z.number().int().nonnegative(),
});
/**
 * 시즌 배너 payload. Wave 0 은 항상 `null`.
 */
export const seasonSchema = z.object({
    id: z.string(),
    name: z.string(),
    startsAt: z.string().datetime({ offset: true }),
    endsAt: z.string().datetime({ offset: true }),
    ctaHref: z.string(),
});
/**
 * GET /api/v1/public/landing 응답.
 * Next.js Route Handler `apps/web/src/app/api/public/landing/route.ts` 가 이 shape 을
 * ISR 60s 로 캐시해 `/` RSC 에 전달.
 */
export const publicLandingResponseSchema = z.object({
    liveCards: z.array(liveCardSchema).max(6),
    socialProof: socialProofSchema,
    season: seasonSchema.nullable(),
    fetchedAt: z.string().datetime({ offset: true }),
});
//# sourceMappingURL=public-landing.rest.js.map